import { NetworkStatus } from '@cbridge-utils/network';
import { IApiUserSettings } from '@cbridge-packages/api';

/** First segment of a layout setting key: the app section whose sidebar/pages the setting belongs to. */
export enum UserSettingsSection {
  Config = 'config',
  Dashboards = 'dashboards',
  Reporting = 'reporting',
  RiskManagement = 'risk-management',
}

export interface IUserSettingsStoreSegment {
  userSettings: IUserSettingsState;
}

export interface IUserSettingsState {
  settings: IApiUserSettings;
  networkStatus: NetworkStatus;
}
